import { post } from "../index";

export function ocrUpload(body) {
  return post(`/ocr/file`, body);
}
